/* eslint-disable */
import Config from '@enlyt/helpers/env'
import { PAST_APPOINTMENTS_COUNT_FOR_FIRST_PAGE } from '@web/helpers/sources'
import cloudAxios from '@enlyt/base/services/cloudAxios'
import { Auth } from '@aws-amplify/auth'

const GET_UPCOMING_APPOINTMENTS = `
    query AppointmentLookup($patientId: String) {
      appointmentLookup(params: {patientId: $patientId}) {
        appointments {
          appointmentId
          lastUpdated
          appointmentIdType
          appointmentType
          date
          time
          duration
          timeZone
          departmentName
          departmentAddress {
            type
            street
            streetLines
            houseNumber
            city
            zip
            district
            county
            state
            country
          }
          departmentPhones {
            system
            use
            type
            number
          }
          patientInstructions
          providerName
          providerId
        }
      }
    }
`
const GET_PAST_APPOINTMENTS = `
  query AppointmentPast($patientId: String, $nextUrl: String, $count: Int, $includeLocationsData: Boolean, $includeAppointmentsData: Boolean) {
    appointmentPast(params: {patientId: $patientId, nextUrl: $nextUrl, count: $count, includeLocationsData: $includeLocationsData, includeAppointmentsData: $includeAppointmentsData}) {
      nextUrl
      appointments {
        id
        appointmentId
        appointmentExtraData {
          serviceType
        }
        lastUpdated
        datetime
        duration
        timeZone
        visitType
        providerName
        departmentName
        departmentAddress {
          type
          street
          streetLines
          houseNumber
          city
          zip
          district
          county
          state
          country
        }
        departmentPhones {
          system
          use
          type
          number
        }
      }
    }
  }
`

const getAppointments = async (
  isUpcoming,
  patientId,
  token,
  nextUrl = null,
  count = PAST_APPOINTMENTS_COUNT_FOR_FIRST_PAGE,
  includeLocationsData = false,
  includeAppointmentsData = true
) => {
  let jwtToken
  if (token) {
    jwtToken = token
  } else {
    const session = await Auth.currentSession()
    jwtToken = session?.accessToken?.jwtToken
  }
  try {
    const result = await cloudAxios({
      url: token
        ? `${Config.EH_CLOUD_API_URL}graphql/auth0`
        : `${Config.EH_CLOUD_API_URL}graphql`,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwtToken}`
        // ...other headers
      },
      data: {
        query: isUpcoming ? GET_UPCOMING_APPOINTMENTS : GET_PAST_APPOINTMENTS,
        variables: {
          patientId,
          nextUrl,
          count,
          includeLocationsData,
          includeAppointmentsData
        }
      },
      // TanStack Query handles all retries for this endpoint — disable
      // axios-retry here so the two layers don't compound to 16 attempts
      // (4 axios × 4 TanStack) on a single 502 / network error.
      'axios-retry': { retries: 0 }
    })
    if (result?.data?.data) {
      return result.data.data
    } else {
      return {}
    }
  } catch (error) {
    console.log(error)
    throw error
  }
}

export const getUpcomingAppointments = async (patientId, token) => {
  return getAppointments(true, patientId, token)
}

export const getPastAppointments = async (patientId, token, nextUrl = null) => {
  return getAppointments(
    false,
    patientId,
    token,
    nextUrl,
    PAST_APPOINTMENTS_COUNT_FOR_FIRST_PAGE
  )
}
